import React, { Component } from "react";

import Mercenary_01 from "../../images/GameTheme/RoleComponent/Mercenary_01.png";
import Weapon_01 from "../../images/GameTheme/WeaponComponent/Weapon_01.png";
import Weapon_02 from "../../images/GameTheme/WeaponComponent/Weapon_03.png";
import Weapon_03 from "../../images/GameTheme/WeaponComponent/Weapon_04_2.png";
import Weapon_04 from "../../images/GameTheme/WeaponComponent/Weapon_06.png";
import Weapon_05 from "../../images/GameTheme/WeaponComponent/Weapon_07.png";

class Role1 extends Component {
    render() {
        var len = Object.values(this.props.Certs).filter(item => item === true).length
        var counter = len > 5 ? 5 : len;
        return (
            <div>
                <img src={Mercenary_01} alt="..."
                    style={{
                        position: 'absolute',
                        height: '150px',
                        top: '300px',
                        left: '100px'
                    }} />
                {renderWeapon(counter)}
            </div>
        );
    }
}

function renderWeapon(value) {
    switch (value) {
        case 1:
            return <img src={Weapon_01} alt="..." style={{ position: 'absolute', height: '100px', left: '165px', top: '350px' }} />;
        case 2:
            return <img src={Weapon_02} alt="..." style={{ position: 'absolute', height: '100px', left: '170px', top: '340px' }} />;
        case 3:
            return <img src={Weapon_03} alt="..." style={{ position: 'absolute', height: '100px', left: '175px', top: '340px' }} />;
        case 4:
            return <img src={Weapon_04} alt="..." style={{ position: 'absolute', height: '100px', left: '175px', top: '350px' }} />;
        case 5:
            return <img src={Weapon_05} alt="..." style={{ position: 'absolute', height: '100px', left: '190px', top: '330px', transform: 'scaleX(-1)' }} />;
        default:
            return null;
    }
}

export default Role1;



// WEBPACK FOOTER //
// ./src/components/Game/Role1.js